import { ReportStateModel } from 'modules/dashboard/types';
import { StepStateType } from 'bff';
import { StepperCategoryState } from 'types/stepper/proposal-stepper-type';

const stepNumbers = [1, 2, 3, 4, 5, 6] as const;

type StepNumber = (typeof stepNumbers)[number];

type StepConfig = {
  step: StepNumber;
  title: string;
  state: StepperCategoryState;
  customIsDisabled?: boolean;
};

export const mapStepStateToStepper = (stepState: StepStateType): StepperCategoryState => {
  switch (stepState) {
    case StepStateType.Default:
      return StepperCategoryState.DEFAULT;
    case StepStateType.Invalid:
      return StepperCategoryState.ERROR;
    case StepStateType.Complete:
      return StepperCategoryState.COMPLETED;
    default:
      return StepperCategoryState.DEFAULT;
  }
};

export const getReportStepConfig = (formState: ReportStateModel): StepConfig[] => [
  {
    step: 1,
    title: 'Select Clients',
    state: mapStepStateToStepper(formState.step1)
  },
  {
    step: 2,
    title: 'Report Period and Content',
    state: mapStepStateToStepper(formState.step2)
  },
  {
    step: 3,
    title: 'Review And Generate',
    state: mapStepStateToStepper(formState.step3)
  }
];
